import type { TextBoxColors } from 'atoms/TextBox'
import type { IListProps } from './List'

import { styled } from '@linaria/react'
import { COLOR, INDENTS } from 'vars/index'
import { Divider } from './List.h'

export const DividerStyled = styled.div<{ divider: IListProps['divider'] }>`
  align-self: center;

  &[data-type=${Divider.Dot}] {
    min-width: 2px;
    height: 2px;
    border-radius: 100%;
    background-color: var(${COLOR.TEXT_ICON_SECONDARY});
  }

  // &[data-type='line'] {
  //   &:after {content: '/'}
  // }
`

// TODO: replace gap with negative margins? https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Mastering_Wrapping_of_Flex_Items#creating_gutters_between_items
type ListStyledProps = Omit<IListProps, 'color' | 'wrap'> & {
  colorDefault?: TextBoxColors
  listWrap?: IListProps['wrap']
}

export const ListStyled = styled.div<ListStyledProps>`
  width: ${({ width }) => (width ? `${width}%` : 'auto')};
  height: ${({ height }) => (height ? `${height}%` : 'auto')};
  display: flex;
  flex-direction: ${({ direction }) => direction || 'row'};
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
  align-items: ${({ alignItems }) => alignItems || 'flex-start'};
  flex-wrap: ${({ listWrap }) => (listWrap ? 'wrap' : 'nowrap')};
  row-gap: ${({ rowGap = INDENTS.INDENT_20 }) => `var(${rowGap})`};
  column-gap: ${({ divider, columnGap }) =>
    divider ? `calc(var(${columnGap}) / 2)` : `var(${columnGap})`};
  color: ${({ colorDefault }) =>
    colorDefault ? `var(${colorDefault})` : 'inherit'};
  padding: ${({ paddings }) =>
    paddings
      ? paddings.map((padding) => (padding ? `var(${padding})` : `0`)).join(' ')
      : ''};
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? `var(${backgroundColor})` : 'unset'};
  flex-grow: ${({ flexGrow = 0 }) => flexGrow};
  flex-shrink: ${({ flexShrink = 0 }) => flexShrink};
  margin: ${({ margins }) =>
    margins
      ? margins.map((margin) => (margin ? `var(${margin})` : `0`)).join(' ')
      : ''};
`
